import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';

const _types = [];

const LocationTypeStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
	    this.emit(CHANGE_EVENT);
    },

    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },

    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },

    removeChangeListener: function(callback) {
        this.removeListener(event, callback);
    },
    
    getById: function(id) {
        return _types.find(t => !!t && t.id === id);
    },

    getAll: function() {
        return [..._types];
    },

    add: function(locationType) {
        const index = _types.findIndex(t => !!t && t.id === locationType.id);
        if (0 <= index ) {
            _types[index] = locationType;
        } else {
            _types.push(locationType);
        }
    }

});

LocationTypeStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.LOCATION_TYPE_LIST:
            _types.splice(0);
            action.data.forEach(LocationTypeStore.add);
            LocationTypeStore.emitChange();
            break;

        case ActionTypes.LOCATION_TYPE_LIST_ERROR:
            LocationTypeStore.emitChange();
            break;
        default:
            break;

    }

});

const _statuses = [];

const LocationStatusStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },

    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },

    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getById: function(id) {
        return _statuses.find(s => !!s && s.id === id);
    },
    getAll: function() {
        return [..._statuses];
    },
    add: function(locationStatus) {
        const index = _statuses.findIndex(s => !!s && s.id === locationStatus.id);
        if (0 <= index ) {
            _statuses[index] = locationStatus;
        } else {
            _statuses.push(locationStatus);
        }
    }

});

LocationStatusStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.LOCATION_STATUS_LIST:
            _statuses.splice(0);
            action.data.forEach(LocationStatusStore.add);
            LocationStatusStore.emitChange();
            break;
        case ActionTypes.LOCATION_STATUS_LIST_ERROR:
            LocationStatusStore.emitChange();
            break;

        default:
    }

});


export { LocationTypeStore };
export { LocationStatusStore };
